import { ButtonGroup, makeStyles, useTheme } from '@rneui/themed'
import { StyleProp, View, ViewStyle } from 'react-native'
import { useThemeChange } from 'settings/change_theme'

interface ButtonGroupProps {
  buttons: (string | React.ReactElement<{}>)[]
  onPress?(...args: any[]): void
  selectedIndex?: number | null
  greyBackground?: boolean
  containerStyle?: StyleProp<ViewStyle>
}

export function ButtonGroupComponent({ ...props }: ButtonGroupProps) {
  const { dark } = useThemeChange()
  const styles = useStyles(dark)
  const { theme } = useTheme()
  return (
    <View
      style={[
        styles.section,
        props.greyBackground && { backgroundColor: theme.colors?.grey5 },
      ]}
    >
      <ButtonGroup
        buttons={props.buttons}
        selectedIndex={props.selectedIndex}
        onPress={props.onPress}
        containerStyle={[styles.tabContainer, props.containerStyle]}
        buttonStyle={styles.tab}
        selectedButtonStyle={styles.selectedButton}
        selectedTextStyle={{
          color: theme.colors?.black,
        }}
        textStyle={{
          color: dark ? theme.colors?.grey3 : theme.colors?.grey6,
        }}
        innerBorderStyle={{ width: 0 }}
      />
    </View>
  )
}

const useStyles = makeStyles((theme, dark: boolean) => ({
  section: {
    width: '100%',
    backgroundColor: theme.colors?.white,
    alignItems: 'center',
    height: 50,
    paddingBottom: 10,
    overflow: 'visible',
    zIndex: 1,
  },
  selectedButton: {
    backgroundColor: dark ? theme.colors.grey10 : theme.colors?.white,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    borderRadius: 10,
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    overflow: 'visible',
  },
  tabContainer: {
    width: '80%',
    marginBottom: 20,
    padding: 2,
    borderRadius: 10,
    justifyContent: 'space-around',
    backgroundColor: dark ? theme.colors?.white : theme.colors?.divider,
    overflow: 'hidden',
    borderColor: dark ? theme.colors.grey10 : theme.colors?.white,
  },
  tab: {
    alignContent: 'center',
    textAlign: 'center',
    textAlignVertical: 'center',
    borderRadius: 8,
  },
}))
